"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.launchApplication = void 0;
var react_1 = __importDefault(require("react"));
var doshx_controls_web_1 = require("doshx_controls_web");
var main_1 = require("../../../../reducers/slices/main");
var sampleAppController_1 = require("../../../../../facetec/src/sampleAppController");
var launchApplication = function (props) {
    var title = props.title, form = props.form, dispatch = props.dispatch, user = props.user;
    if (!(user === null || user === void 0 ? void 0 : user.uid)) {
        dispatch((0, main_1.setMessageModal)({ title: "Sign In Required", messages: ["Please sign in first before applying for this job"] }));
    }
    else if (!(user === null || user === void 0 ? void 0 : user.SumSubApproved)) {
        dispatch((0, main_1.setContentModal)({
            title: "KYC Verification",
            content: (react_1.default.createElement("div", { className: "flex flex-col justify-start gap-3" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "A completed KYC verification is required." }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Please complete the KYC process to proceed with your application." }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Benefits and CTA to complete KYC" }),
                react_1.default.createElement("div", { className: "flex flex-row justify-center gap-2" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Cancel", backgroundColor: "bg-primary", size: "small", onClick: function () {
                            dispatch((0, main_1.setContentModal)(null));
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Continue to KYC", backgroundColor: "bg-secondary", size: "small", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (!user.facetecDBRef || (user.facetecDBRef && !user.facetec.authenticated)) {
                                    if (!user.facetecDBRef)
                                        sampleAppController_1.SampleApp.onEnrollUserPressed();
                                    if (user.facetecDBRef && !user.facetec.authenticated)
                                        sampleAppController_1.SampleApp.onAuthenticateUserPressed();
                                }
                                else {
                                    sampleAppController_1.SampleApp.onPhotoIDMatchPressed();
                                }
                                dispatch((0, main_1.setContentModal)(null));
                                return [2 /*return*/];
                            });
                        }); } })))),
        }));
    }
    else {
        dispatch((0, main_1.setContentModal)({
            title: title,
            content: form,
        }));
    }
};
exports.launchApplication = launchApplication;
